import offer_logo from "../image/catalog/demo/banners/Offer.png";
import { Typography } from "@mui/material";
const Offer = ({ item, ind }) => {
  return (
    <>
      {/* <div className="offer-item" key={ind}>
        <img src={item?.image} alt="offer_logo" width="60px" height="60px" />

        <div> */}
      {/* <Typography ml={2}>
            <strong>
              {item?.name} */}
      {/* Micro Labs Ltd Bonus Offer */}
      {/* </strong>
          </Typography> */}
      {/* <Typography mt={1} ml={2}>
            {" "}
            {item?.type} */}
      {/* Buy min Qty 100 get 10 Qty as Bonus */}
      {/* </Typography> */}
      {/* </div> */}
      {/* </div> */}
      <div className="offer-item" key={ind}>
        {item?.image && (
          <img src={item.image} alt="offer_logo" width="60px" height="60px" />
        )}

        <div>
          <Typography ml={2}>
            <strong>
              {item?.name}
              {/* Micro Labs Ltd Bonus Offer */}
            </strong>
          </Typography>
          <Typography mt={1} ml={2}>
            {" "}
            {item?.type}
            {/* Buy min Qty 100 get 10 Qty as Bonus */}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default Offer;
